module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAAXNSR0IArs4c6QAAAEtQTFRFAAAA/wAA/4CA/0CA/zNm/2Zm/091/053/1F3/1B1/1B3/052/1B2/093/1B2/091/052/1B1/092/093/093/1B2/051/092/092I6gunQAAABh0Uk5TAAECBAUFZGVlZm11eXp9foaWnqWss/7+8R/IUQAAAEZJREFUGNNjYMAG2HnRBHgkBBlRRQQkhJhQRfglhJlRRbjFRVhRRbjERNHUcEiwoQpwogkAtbDgM5QPzVp0h2E4HcNzyAAAc9gCugzKKSEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/open/icon_arrow_red.png
// module id = 3mG7
// module chunks = 0